import {GridWidgetDataField} from './grid-widget-data-field';
import {GridWidgetFilter} from './grid-widget-filter';
import {OrderedMap} from '../ordered-map';
import {MultiFieldFilter} from './multi-field-filter';

/**
 * The idea here is to create the simple filter functionality as its own encapsulated filter.
 * That means this thing needs to keep track of all of the dataFields that the MultiFieldFilter
 * filters on.  This object is here to hold all of those internal fields.
 */
export class MultiField extends GridWidgetDataField {

  validationRules: MultiFieldValidationRules;

  dataFields: OrderedMap<GridWidgetDataField>;

  placeholderText = '';

  constructor(id: string, title: string, dataFields: OrderedMap<GridWidgetDataField>, sortOrder?: number) {
    super(id, function(o: Object): any { return o; }, title, sortOrder);
    this.dataFields = dataFields;

    //We don't support multi-fields exporting to CSV.
    this.fieldExportDisabled = true;
  }

  getFilterInstance(): GridWidgetFilter {
    return new MultiFieldFilter(this);
  }

  setValidationRules(rules: MultiFieldValidationRules): void {
    this.validationRules = rules;
  }

  resolveAsString(dataRow: any): string {
    console.error(`Multi-Field is not supported for exporting to string`);
    return '';
  }
}

export type MultiFieldValidationRules = {
  'data-customvalidate'?: string,
  'data-excludechars'?: string,
  'data-maxlength'?: string,
  'data-minlength'?: string,
  'data-regex'?: string,
  'data-regex-error-text'?: string
};
